import React from 'react'
import styled from 'styled-components'
import ModalWindow from '@shared/ModalWindow/ModalWindow'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import { useList } from 'effector-react'
import { $cities } from '@entities/cities/model'
import { useChangeCity, useChangeStock } from '@entities/shipment/model'
import { useToggleCitySelector } from 'src/features/shipment-selector/hooks'

export const SelectorRegion = styled.div`
    display: flex;
    flex-direction: column;
`
export const ComboboxCityItem = styled.div`
    color: ${ThemeColors.getGrayColor(0.5)};

    :hover {
        color: ${ThemeColors.accentGreen};
    }
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    color: ${ThemeColors.getGrayColor(0.4)};
    font-size: 1.1rem;
    justify-content: space-between;

    & > div {
        margin-bottom: 1rem;
    }
`

export const ContentRow = styled.div`
    cursor: pointer;

    :hover {
        color: ${ThemeColors.accentGreen};
    }
`

export const CitySelectorDesktop = () => {
    const changeCity = useChangeCity()
    const toggleCitySelector = useToggleCitySelector()
    return (
        <ModalWindow
            title="Выберите ваш регион"
            isButtonFooter={false}
            cancel={{
                text: 'Отмена',
                clickHandler: toggleCitySelector
            }}>
            <SelectorRegion>
                <Container>
                    {useList($cities, {
                        getKey: (city) => city.id,
                        fn: (city) => (
                            <ContentRow onClick={() => changeCity(city.id)} data-city-id={city.id}>
                                <ComboboxCityItem>{city.title}</ComboboxCityItem>
                            </ContentRow>
                        )
                    })}
                </Container>
            </SelectorRegion>
        </ModalWindow>
    )
}
